import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Modal from "common/components/Modal/Modal";
import ToggleSwitch from "common/components/ToggleSwitch/ToggleSwitch";

type Props = {
  visible: boolean;
  isSaving: boolean;
  startDate: any;
  endDate: any;
  onCancel: () => void;
  onConfirm: (values: { name: string; isFrozen: boolean }) => void;
};

function SaveBalanceSheetModal({
  visible,
  isSaving,
  startDate,
  endDate,
  onCancel,
  onConfirm,
}: Props) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [isFrozen, setIsFrozen] = useState(true);

  // Reset to a fresh default name each time the modal is opened.
  useEffect(() => {
    if (visible) {
      setName(
        t("balance.defaultName", {
          startDate: dayjs(startDate).format("L"),
          endDate: dayjs(endDate).format("L"),
        })
      );
      setIsFrozen(true);
    }
  }, [visible, startDate, endDate, t]);

  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      title={t("balance.saveModalTitle")}
      confirmBtnLabel={t("actions.save")}
      disableConfirmBtn={isSaving || !name.trim()}
      onCloseModal={onCancel}
      onConfirmModal={() => onConfirm({ name: name.trim(), isFrozen })}
    >
      <div className="flex flex-col gap-6 text-left text-slate-600">
        <label className="flex flex-col gap-1">
          <span className="font-semibold">{t("balance.saveName")}</span>
          <input
            type="text"
            className="text-input-white"
            value={name}
            placeholder={t("balance.saveNamePlaceholder")}
            onChange={(e) => setName(e.target.value)}
          />
        </label>

        <ToggleSwitch
          value={isFrozen}
          onChange={setIsFrozen}
          rightLabel={t("balance.freezeData")}
          legende={
            isFrozen
              ? t("balance.freezeDataLegend")
              : t("balance.liveDataLegend")
          }
        />
      </div>
    </Modal>
  );
}

export default SaveBalanceSheetModal;
